import { Component, inject, Input, OnInit } from '@angular/core';
import { IonLabel, ModalController } from '@ionic/angular/standalone';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { SelectTimerControlComponent } from '../../../../../../../../components/ecosystems/select-timer-control/select-timer-control.component';
import { ModeControlMultipleComponent } from '../../../../../../../../components/ecosystems/mode-control-multiple/mode-control-multiple.component';
import { ModeControlSimpleComponent } from '../../../../../../../../components/ecosystems/mode-control-simple/mode-control-simple.component';
import { IProduct } from '../../../../../IProduct';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';
import {
  convertMinutesToTime,
  convertSecondsToTime,
} from '../../../../../../helper/convertSecondsToTime';
import { P00039WelticoV2ColorChoiceComponent } from '../../components/p00039-weltico-v2-color-choice/p00039-weltico-v2-color-choice.component';
import { getColorDescriptor } from '../../../../../../../../components/ecosystems/function-parameters-settings-weltico2-clock-screen/function-parameters-settings-weltico2-clock-screen.component';

@Component({
  selector: 'app-p00039-eclairage-controle',
  templateUrl: './p00039-eclairage-controle.component.html',
  styleUrls: ['./p00039-eclairage-controle.component.scss'],
  imports: [
    IonLabel,
    TranslatePipe,
    ModeControlMultipleComponent,
    ModeControlSimpleComponent,
  ],
})
export class P00039EclairageControleComponent implements OnInit {
  private modalController: ModalController = inject(ModalController);
  private translateService: TranslateService = inject(TranslateService);

  @Input() productClass: IProduct | null = null;
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);

  public actionStack: DeviceActionStackService | null = null;

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );
  }

  async openDateSelector() {
    if (
      this.actionStack!.getValue('eclairageStandardCDemarrageMinuterie') !== 0
    ) {
      return;
    }

    const modal = await this.modalController.create({
      component: SelectTimerControlComponent,
      componentProps: {
        value: this.actionStack!.getValue('eclairageStandardPDureeMinuterie'),
        title: this.translateService.instant(
          'P00039.parameters.setting.setting.timer.btn',
        ),
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;

      this.actionStack!.editValue(
        P00039DataRxTxIndex.Eclairage_Parametrage,
        'eclairageStandardPDureeMinuterie',
        hj,
      );
      this.actionStack!.commit();
    }
  }

  getColorData() {
    const colorDescriptor = getColorDescriptor(
      this.actionStack!.getValue('eclairageStandardITypeEclairage'),
      this.actionStack!.getValue('eclairageStandardPCodeProgrammeWeltico'),
    );

    return {
      label: colorDescriptor?.title ?? '',
      color:
        colorDescriptor && !colorDescriptor.forceTextBlackOnSelect
          ? 'color-white'
          : 'color-secondary',
      backgroundColor: colorDescriptor ? colorDescriptor.color : '#00000000',
      backgroundImage:
        colorDescriptor && colorDescriptor.selectedImage
          ? colorDescriptor.selectedImage
          : null,
      icon: 'fa-regular fa-arrow-right-from-line',
    };
  }

  async openColorSelector() {
    const modal = await this.modalController.create({
      component: P00039WelticoV2ColorChoiceComponent,
      componentProps: {
        value: this.actionStack!.getValue(
          'eclairageStandardPCodeProgrammeWeltico',
        ),
        colorType: this.actionStack!.getValue(
          'eclairageStandardITypeEclairage',
        ),
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;

      this.actionStack!.editValue(
        P00039DataRxTxIndex.Eclairage_Parametrage3,
        'eclairageStandardPCodeProgrammeWeltico',
        data.value,
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.Eclairage_Controle,
        'eclairageStandardCSynchronisationProgramme',
        1,
      );
      this.actionStack!.commit();
    }
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly convertMinutesToTime = convertMinutesToTime;
  protected readonly convertSecondsToTime = convertSecondsToTime;
}
